






























































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { Button, Checkbox, FormItem, Option, Select, Tooltip } from 'element-ui';
import NullableInput from '@/components/element-ui/NullableInput.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import locations from '@/mixins/locationOptions.ts';
import { milestoneService } from '@/services/MilestoneService';
import {
  MilestoneTypeEnum,
  MilestoneInput,
  ShipmentFields,
  MilestoneFields,
  DevanningContainerInput,
  DeliveryPlaceInput
} from '@/types/graphql/schemaTypes';
import get from 'lodash/get';
import debounce from 'lodash/debounce';

@Component({
  components: {
    UtcDatePicker,
    'el-button': Button,
    'el-checkbox': Checkbox,
    'el-form-item': FormItem,
    'el-input': NullableInput,
    'el-option': Option,
    'el-select': Select,
    'el-tooltip': Tooltip
  }
})
export default class Devanning extends Mixins(locations) {
  @Prop({ required: true }) private milestone!: MilestoneFields;
  @Prop({ required: true }) private shipment!: ShipmentFields;

  private emptyDeliveryPlace: DeliveryPlaceInput = {
    deliveryPlace: null,
    deliveryDate: null,
    drayageReserved: false
  };

  public customerOrganization = {
    id: this.shipment.customerOrganization.id
  };

  private debouncer = debounce((self) => { self.$emit('update', self.milestoneInput); }, 300);
  private deliveryPlaceInput: DeliveryPlaceInput[] =
    get(
      this.milestone,
      'devanningDetails.container.deliveryPlaces',
      [{ ...this.emptyDeliveryPlace }]
    )
  ;

  private loading = false;
  private milestoneInput: MilestoneInput = {
    devanningDate: get(this.milestone, 'devanningDate', null),
    devanningDetails: {
      container: {
        containerNumber: get(
          this.milestone,
          'devanningDetails.container.containerNumber'
        ),
        containerReference: get(
          this.milestone,
          'devanningDetails.container.containerReference'
        ),
        deliveryPlaces: this.deliveryPlaceInput
      }
    }
  };

  created() {
    // remove creation option in locationOptions
    this.addCreation = false;
  }

  private addDelivery() {
    this.$set(
      this.deliveryPlaceInput,
      this.deliveryPlaceInput.length,
      { ...this.emptyDeliveryPlace }
    );
  }

  private deleteDelivery(index: number) {
    this.$delete(
      this.deliveryPlaceInput,
      index
    );
  }

  @Watch('deliveryPlaceInput', { deep: true })
  private updateDeliveryPlace() {
    this.milestoneInput!.devanningDetails!.container!.deliveryPlaces! = this.deliveryPlaceInput;
  }

  @Watch('milestoneInput', { deep: true })
  private update(milestoneInput: MilestoneInput) {
    this.debouncer(this);
  }
}
